import { BirdviewCard } from '../BirdviewCard'
import { BirdviewHomeRow } from '../BirdviewHomeRow'

function BirdviewHomeWidget({ dragHandleProps, section, title }) {
  return (
    <BirdviewCard
      dragHandleProps={dragHandleProps}
      isRefreshing={section.isRefreshing}
      skeletonProps={{ hasAction: false, hasMeta: false }}
      state={section.state}
      title={title}
      onRetry={section.reload}
    >
      {section.items.map(item => (
        <BirdviewHomeRow item={item} key={item.id} />
      ))}
    </BirdviewCard>
  )
}

export default BirdviewHomeWidget
